<template>
  <div class="recharge">
    <headerNotice :routerName="getTypeTitl"></headerNotice>
    <div class="content-wrapper">
      <!-- 提示信息 -->
      <div class="alert-wrapper">
        <el-alert style="background: #e6f7ff;color: #82bcfd;" type="info" show-icon>
          <div class="title" slot="title">提示</div>
          <div class="desc">
            <p>充值满赠活动时间结束后只显示充值{{getTypeDesc}}。</p>
            <p>开启新用户专享，充值满赠活动只有新注册用户才显示。</p>
          </div>
        </el-alert>
      </div>
      <!-- 表单 -->
      <el-form class="form" :model="form" v-loading='loading'>
        <!-- 日期选择 -->
        <div class="date-wrapper">
          <el-row>
            <el-col :span="7">
              <el-form-item :rules="required" label="开始时间：">
                <el-date-picker
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="start"
                  type="datetime"
                  placeholder="选择日期时间"
                  style="width:200px;"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item :rules="required" label="结束时间：">
                <el-date-picker
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="end"
                  type="datetime"
                  placeholder="选择日期时间"
                  style="width:200px;"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :rules="required" label="限制：">
              <!-- 次数限制 -->
              <el-input
                v-if='type == 1'
                type='number'
                placeholder="0为无限次"
                style="width:170px;"
                v-model.number="participaTimes"
              >
                <template slot="append">次</template>
              </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-checkbox style='margin-left: 12%' v-model="isNewMan">是否新用户专享</el-checkbox> -->
        </div>
        <!-- 充值项 -->
        <ul class="item-wrapper">
          <li v-for="(item, i) in packData" class="recharge-item" :key="i">
            <el-form-item :rules="{required: required}" :label="i | getLabel">
              <span>充值{{getTypeDesc}}</span>
              <!-- 余额 -->
              <el-input
                v-if='type == 1'
                type='number'
                style="width:170px; margin: 0 16px;"
                placeholder="请输入内容"
                v-model.number="item.packAmount"
              >
                <template slot="append">{{getTypeUnit}}</template>
              </el-input>
              <!-- 积分 -->
              <el-input
                v-if='type == 2'
                type='number'
                style="width:170px; margin: 0 16px;"
                placeholder="请输入内容"
                v-model.number="item.packIntegral"
              >
                <template slot="append">{{getTypeUnit}}</template>
              </el-input>
              <span>赠送</span>
              <el-select placeholder="类型" v-model="item.sendType" style="width:80px; margin: 0 6px 0 16px;">
                <el-option selected :value="1" label='金额'></el-option>
                <el-option :value="2" label='积分'></el-option>
              </el-select>
              <!-- 余额 -->
              <el-input
                v-if='type==1'
                type='number'
                style="width:170px; margin: 0 16px;"
                placeholder="请输入内容"
                v-model.number="item.sendAmount"
              >
                <template slot="append">{{item.sendType == 1 ? '元' : '个'}}</template>
              </el-input>
              <!-- 积分 -->
              <el-input
                v-if='type==2'
                type='number'
                style="width:170px; margin: 0 16px;"
                placeholder="请输入内容"
                v-model.number="item.sendIntegral"
              >
                <template slot="append">{{getTypeUnit}}</template>
              </el-input>
              <el-button @click="delRechargeItem(i)" type="text" v-show="i != 0">删除</el-button>
            </el-form-item>
          </li>
        </ul>
        <el-form-item class="btn-wrapper">
          <el-button @click="addRechargeItem">新增</el-button>
          <el-button :loading='loading' type="primary" @click="saveItem">保存</el-button>       
          <!-- <el-button @click="delRechargeItem">删除</el-button> -->
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
export default {
  components: {
    headerNotice
  },
  props: ["routerName", "type", "exclusive"],
  data() {
    return {
      loading: false,
      label: [1],
      packData: [{ sendType: 1 }],
      start: "",
      end: "",
      participaTimes: "",
      isNewMan: false,
      required: {
        required: true
      },
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      }
    };
  },
  watch: {},
  computed: {
    getTypeTitl() {
      let user = this.exclusive == 1 ? "新用户" : "老用户";
      let type = this.type == 1 ? "金额充值套餐" : "积分充值套餐";
      return user + type;
    },
    getTypeDesc() {
      return this.type == 1 ? "金额" : "积分";
    },
    getTypeUnit() {
      return this.type == 1 ? "元" : "分";
    }
  },
  methods: {
    // 保存input信息
    saveItem() {
      let pack = [];
      let count = 0;

      if (this.type == 1) {
        this.packData.forEach(item => {
          pack.push({
            packAmount: item.packAmount,
            sendAmount: item.sendAmount,
            sendType: item.sendType
          });
        });
        var check = pack.findIndex(item => {
          return (
            !this.isMoney(item.packAmount) ||
            !this.isMoney(item.sendAmount) ||
            item.sendType == 0
          );
        });
      } else {
        this.packData.forEach(item => {
          pack.push({
            packIntegral: item.packIntegral,
            sendIntegral: item.sendIntegral,
            sendType: item.sendType
          });
        });
        var check = pack.findIndex(item => {
          return (
            !this.isInt(item.packIntegral) ||
            !this.isInt(item.sendIntegral) ||
            item.sendType == 0
          );
        });
      }
      // console.log(check)
      if (check != -1) {
        let message = "";
        if (pack[check].sendType == 0) {
          message = "请选择赠送类型！";
        } else {
          message = "请填写正确的数字！";
        }
        this.$message.error(message);
        return;
      }
      if (!this.isIntOrZero(this.participaTimes)) {
        this.$message.error("请填写正确的数字！");
        return;
      }
      this.savePack({
        exclusive: this.exclusive,
        startTime: this.start,
        endTime: this.end,
        participaTimes: this.participaTimes,
        pack: pack
      });
      // console.log({
      //   exclusive: this.exclusive,
      //   startTime: this.start,
      //   endTime: this.end,
      //   pack: pack
      // })
    },
    // 保存充值信息
    savePack(data) {
      // console.log(data)
      // return
      let path = this.type == 1 ? "SaveBalancePack" : "SaveIntegralPack";
      let self = this;
      self.loading = true;
      $http.POST({
        url:
          this.$store.state.apiUrl + "/api/services/app/RechargePack/" + path,
        data: data,
        success(res) {
          // console.log(res);
          self.loading = false;
          self.$message({
            showClose: true,
            message: "操作成功！",
            type: "success"
          });
          self.getPack({
            exclusive: self.exclusive
          });
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    // 获取充值信息
    getPack(params) {
      let path = this.type == 1 ? "GetBalancePack" : "GetIntegralPack";
      let self = this;
      self.loading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl + "/api/services/app/RechargePack/" + path,
        params: params,
        success(res) {
          // console.log(res);
          if (res.length) {
            self.packData = res;
            self.start = res[0].startTime;
            self.end = res[0].endTime;
            self.participaTimes = res[0].participaTimes;
          }
          self.loading = false;
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    addRechargeItem() {
      this.packData.push({ sendType: 1 });
    },
    delRechargeItem(i) {
      if (this.packData.length > 1) {
        this.packData.splice(i, 1);
      } else {
        this.$message({
          showClose: true,
          message: "最少保留一项",
          type: "warning"
        });
      }
    },
    isMoney(money) {
      return /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/.test(
        money
      );
    },
    isInt(num) {
      return /^(([0-9]*[1-9][0-9]*))$/.test(num);
    },
    isIntOrZero(num) {
      return /^(([0-9]*[1-9][0-9]*))$|0/.test(num);
    }
  },
  created() {
    this.getPack({
      exclusive: this.exclusive
    });
  },
  mounted() {},
  filters: {
    getLabel(idx) {
      return `充值${idx + 1}:`;
    }
  }
};
</script>
<style lang="scss" scoped>
.recharge {
  .content-wrapper {
    padding: 0 200px 0;
    // 提示信息
    .alert-wrapper {
      margin: 20px 0 30px;
      border: 1px solid #91d5ff;
      border-radius: 4px;
      .title {
        font-size: 16px;
        color: #000000a5;
      }
      .desc {
        margin-top: 10px;
        line-height: 30px;
        font-size: 14px;
        color: #0000006d;
      }
    }
  }
  .form {
    padding-left: 14%;
  }

  .item-wrapper {
    // width: 660px;
    margin: 0 auto 30px;
    // margin-bottom: 20px;
  }
  .btn-wrapper {
    // width: 300px;
    // margin: 0 auto;
    margin-left: 32%;
  }
}
</style>
